"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SharedInstance = /** @class */ (function () {
    function SharedInstance() {
    }
    Object.defineProperty(SharedInstance.prototype, "csrf", {
        get: function () {
            return this._csrf;
        },
        set: function (value) {
            this._csrf = value;
        },
        enumerable: false,
        configurable: true
    });
    return SharedInstance;
}());
exports.default = new SharedInstance();
//# sourceMappingURL=api-shared-data.js.map